var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0468 14.9558C12.5136 15.3356 9.09274 12.9284 8.43756 12.9231C7.78238 12.9178 4.32297 15.2697 3.79605 14.8814C3.26912 14.4931 4.5079 10.505 4.31048 9.88208C4.11307 9.25914 0.800897 6.70512 1.00837 6.08541C1.2159 5.46571 5.40239 5.40815 5.93554 5.0284C6.46868 4.6487 7.88109 0.718393 8.53631 0.723638C9.19145 0.728929 10.54 4.68145 11.067 5.06972C11.5939 5.45796 15.779 5.58293 15.9764 6.20587C16.1738 6.82881 12.8208 9.3292 12.6133 9.9489C12.4058 10.5686 13.5799 14.5761 13.0468 14.9558Z",
    fill: "url(#paint0_linear_1547_129)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1547_129",
    x1: 0.999043,
    y1: 7.86005,
    x2: 15.9848,
    y2: 7.86005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A928"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fa760d65f67211ebf6c751d1b7165d70.svg";
export { ForwardRef as ReactComponent };